import { toMicroSurvey, toWireMicroSurveySubmission } from './mappers';
import type { MicroSurveyGateway } from '../ports/microSurveyGateway';

import { fetchClient } from '@/util/fetchClient';

/**
 * The micro survey's backend, over the generated API client. It swallows every
 * error: the survey is optional, so a failed read shows nothing and a failed
 * write is dropped. Analytics are the hook's job, not this.
 */
export const fetchMicroSurveyGateway: MicroSurveyGateway = {
  async getNextMicroSurvey() {
    try {
      const { data } = await fetchClient.GET('/v2/users/me/micro-survey');

      return data?.data ? toMicroSurvey(data.data) : null;
    } catch {
      return null;
    }
  },

  async submitMicroSurvey(submission) {
    try {
      const { response } = await fetchClient.POST('/v2/users/me/micro-survey', {
        body: toWireMicroSurveySubmission(submission),
      });

      return response.ok;
    } catch {
      return false;
    }
  },
};
